export class DateHelper {
   public static ConvertDate(input: string): Date {
      return new Date(input + "T00:00:00");
   }
}
